<template>
  <div class="add-pay-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="680px" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="160px" :label-position="labelPosition">
        <div class="form-flex-box">
          <el-form-item label="选中图:" prop="newBgImg">
            <base-upload class="upload" :cover="params.newBgImg" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handleNewAvatarSuccess"></base-upload>
          </el-form-item>
          <el-form-item label="未选中图:" prop="outBgImg">
            <base-upload class="upload" :cover="params.outBgImg" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handleBgSuccess"></base-upload>
          </el-form-item>
          <el-form-item label="背景图:" prop="bgImg">
            <base-upload class="upload" :cover="params.bgImg" :action="action" :wSize="180" :hSize="90" :width="'180px'"
              :height="'90px'" @successCallback="handleAvatarSuccess"></base-upload>
          </el-form-item>
        </div>
        <div v-show="isPreSale" class="form-flex-box">
          <el-form-item label="预售背景:" prop="advanceBgImgNew">
            <base-upload class="upload" :cover="params.advanceBgImgNew" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handleNewPresaleSuccess"></base-upload>
          </el-form-item>
          <el-form-item label="预售背景(选中):" prop="advanceBgImg">
            <base-upload class="upload" :cover="params.advanceBgImg" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handlePresaleSuccess"></base-upload>
          </el-form-item>
        </div>
        <div v-show="isPreSale" class="form-flex-box">
          <el-form-item label="尾款背景:" prop="advanceBgImgFinalPayNew">
            <base-upload class="upload" :cover="params.advanceBgImgFinalPayNew" :action="action" :wSize="180"
              :hSize="90" :width="'180px'" :height="'90px'" @successCallback="handleNewFinalPaySuccess"></base-upload>
          </el-form-item>
          <el-form-item label="尾款背景(选中):" prop="advanceBgImgFinalPay">
            <base-upload class="upload" :cover="params.advanceBgImgFinalPay" :action="action" :wSize="180" :hSize="90"
              :width="'180px'" :height="'90px'" @successCallback="handleFinalPaySuccess"></base-upload>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="名称(不可重复):" prop="productName">
            <el-input v-model="params.productName" size="small"></el-input>
          </el-form-item>
          <el-form-item label="新名称:" prop="newName">
            <el-input v-model="params.newName" size="small"></el-input>
          </el-form-item>
          <el-form-item label="原价(金币):" prop="originalPrice">
            <el-input v-model.number="params.originalPrice" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="ios现价(金币):" prop="discountedPriceIos">
            <el-input v-model.number="params.discountedPriceIos" size="small"></el-input>
          </el-form-item>
          <el-form-item label="安卓现价(金币):" prop="discountedPriceAnd">
            <el-input v-model.number="params.discountedPriceAnd" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="产品类型:" prop="productType">
            <el-select v-model="params.productType" size="small" clearable placeholder="请选择产品类型">
              <el-option v-for="item in productTypes" :value="item.value" :label="item.label"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="持续时间(天):" prop="duration">
            <el-input v-model.number="params.duration" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box" v-if="isPreSale">
          <el-form-item label="预付金额:">
            <el-input v-model.number="params.advanceAmount" size="small"></el-input>
          </el-form-item>
          <el-form-item label="尾款金额:">
            <el-input v-model.number="params.balanceAmount" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box" v-if="isPreSale">
          <el-form-item label="支付尾款开始时间:" prop="startTime">
            <el-date-picker type="datetime" v-model="params.startTime" placeholder="选择日期时间"
              size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="支付尾款结束时间:" prop="endTime">
            <el-date-picker type="datetime" v-model="params.endTime" placeholder="选择日期时间" size="small"></el-date-picker>
          </el-form-item>
        </div>
        <div class="form-flex-box" v-if="isPreSale">
          <el-form-item label="活动时间:" prop="activityTime">
            <el-date-picker type="datetime" v-model="params.activityTime" placeholder="选择日期时间"
              size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="所有金币视频免费:">
            <el-switch v-model="params.allGoldVideoFree"></el-switch>
          </el-form-item>
        </div>
        <div v-if="params.productType === 9" class="form-flex-box">
          <el-form-item label="可领楼凤(次/周):" prop="timesAWeek">
            <el-input v-model.number="params.timesAWeek" size="small"></el-input>
          </el-form-item>
        </div>
        <!-- <div
          v-if="params.productType === 0 || params.productType === 5"
          class="form-flex-box"
        >
          <el-form-item label="赠送观影券金币:" prop="goldVideoCouponNum">
            <el-input
              v-model.number="params.goldVideoCouponNum"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="赠送观影券数量:" prop="goldVideoCouponCount">
            <el-input
              v-model.number="params.goldVideoCouponCount"
              size="small"
            ></el-input>
          </el-form-item>
        </div> -->
        <div class="form-flex-box">
          <el-form-item label="楼凤折扣率(%):" prop="louFengDiscount">
            <el-input v-model.number="params.louFengDiscount" size="small"></el-input>
          </el-form-item>
          <el-form-item label="专属特惠:" prop="exclusiveOffer">
            <el-input v-model="params.exclusiveOffer" size="small"></el-input>
          </el-form-item>
          <el-form-item label="服务时间(单位:分钟):" prop="serviceTime" v-if="params.productType === 12">
            <el-input v-model.number="params.serviceTime" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="私信聊天价格:" prop="chatPrice">
            <el-input v-model.number="params.chatPrice" size="small"></el-input>
          </el-form-item>
          <el-form-item label="楼凤预约折扣率(%):">
            <el-input v-model.number="params.loufengBookDiscount" size="small"></el-input>
          </el-form-item>
          <el-form-item label="楼凤预约折扣时间:">
            <el-input v-model.number="params.loufengBookDiscountDays" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="展示单价:">
            <el-switch v-model="params.unitPriceDisplay"></el-switch>
          </el-form-item>
          <el-form-item label="上架:">
            <el-switch v-model="params.status"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="产品位置:" prop="position">
            <el-select v-model="params.position" size="small" clearable placeholder="请选择产品位置">
              <el-option v-for="item in positionTypeList" :value="item.value" :label="item.label"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用金币购买:">
            <el-switch v-model="params.isAmountPay"></el-switch>
          </el-form-item>
        </div>
        <div class="form-flex-box" v-if="params.productType === 21">
          <el-form-item label="是否首页弹窗:">
            <el-switch v-model="params.isHomePopUp"></el-switch>
          </el-form-item>
          <el-form-item label="免费抽奖次数:">
            <el-input v-model.number="params.drawsCount" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="每日ai脱衣次数限制:" prop="aiUndressLimitPerDay">
            <el-input v-model.number="params.prepaidPrivilege.aiUndressLimitPerDay" size="small"></el-input>
          </el-form-item>
          <el-form-item label="每日金币视频免费次数:" prop="coinVideoLimitPerDay">
            <el-input v-model.number="params.prepaidPrivilege.coinVideoLimitPerDay" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="每日下载次数限制:" prop="downloadLimitPerDay">
            <el-input v-model.number="params.prepaidPrivilege.downloadLimitPerDay" size="small"></el-input>
          </el-form-item>
          <el-form-item label="每日抽奖次数限制:" prop="luckyDrawLimitPerDay">
            <el-input v-model.number="params.prepaidPrivilege.luckyDrawLimitPerDay" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="金币视频免费天数:" prop="goldVideoFreeDay">
            <el-input v-model.number="params.goldVideoFreeDay" size="small"></el-input>
          </el-form-item>
          <el-form-item label="排序:" prop="sort">
            <el-input v-model.number="params.sort" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="赠送游戏金币数量:" prop="giveGameCoin">
            <el-input v-model.number="params.giveGameCoin" size="small"></el-input>
          </el-form-item>
          <el-form-item label="楼凤解锁次数:" prop="louFengUnlockTimes">
            <el-input v-model.number="params.louFengUnlockTimes" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="赠送金币数量:" prop="giveCoin">
            <el-input v-model.number="params.giveCoin" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赠送果币数量:" prop="giveFruitCoin">
            <el-input v-model.number="params.giveFruitCoin" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="赠送ai脱衣次数:" prop="aiUndressCount">
            <el-input v-model.number="params.aiUndressCount" size="small"></el-input>
          </el-form-item>
          <el-form-item label="赠送下载次数:" prop="downloadCount">
            <el-input v-model.number="params.downloadCount" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="会员等级:" prop="vipLevel"
            v-if="this.params.productType === 0 || this.params.productType == 5 || isPreSale">
            <el-select v-model="params.vipLevel" size="small" clearable placeholder="请选择会员等级">
              <el-option v-for="item in vipLevelTypeList" :value="item.value" :label="item.label"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="新手卡倒计时:" prop="showCountdownTime" v-if="this.params.productType == 5">
            <el-input v-model.number="params.showCountdownTime" size="small" placeholder="单位：小时"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="支付视频折扣:" prop="payVidDiscount">
            <el-select v-model="params.payVidDiscount" size="small" clearable placeholder="请选择支付视频折扣">
              <el-option :value="0" label="0" key="0"></el-option>
              <el-option :value="1" label="1" key="1"></el-option>
              <el-option :value="2" label="2" key="2"></el-option>
              <el-option :value="3" label="3" key="3"></el-option>
              <el-option :value="4" label="4" key="4"></el-option>
              <el-option :value="5" label="5" key="5"></el-option>
              <el-option :value="6" label="6" key="6"></el-option>
              <el-option :value="7" label="7" key="7"></el-option>
              <el-option :value="8" label="8" key="8"></el-option>
              <el-option :value="9" label="9" key="9"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="params.productType === 13" label="金币视频折扣:" prop="videoDiscount">
            <el-select v-model="params.videoDiscount" size="small" clearable placeholder="请选择金币视频折扣率">
              <el-option :value="1" label="1" key="1"></el-option>
              <el-option :value="2" label="2" key="2"></el-option>
              <el-option :value="3" label="3" key="3"></el-option>
              <el-option :value="4" label="4" key="4"></el-option>
              <el-option :value="5" label="5" key="5"></el-option>
              <el-option :value="6" label="6" key="6"></el-option>
              <el-option :value="7" label="7" key="7"></el-option>
              <el-option :value="8" label="8" key="8"></el-option>
              <el-option :value="9" label="9" key="9"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="渠道分成模式:" prop="chanSplitMod">
            <el-select v-model="params.chanSplitMod" placeholder="请选择渠道分成模式" size="small">
              <el-option v-for="item in chanSplitMods" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="特权:" prop="privilege">
            <el-select v-model="params.privilege" multiple placeholder="请选择特权" class="privileges">
              <el-option v-for="item in privileges" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="备注:" prop="desc">
          <el-input type="textarea" v-model="params.desc" size="small"></el-input>
        </el-form-item>
        <el-form-item label="特权描述:" prop="privilegeDesc">
          <el-input type="textarea" v-model="params.privilegeDesc" size="small"></el-input>
        </el-form-item>
        <el-form-item label="活动描述:" prop="actionDesc">
          <el-input type="textarea" v-model="params.actionDesc" size="small"></el-input>
        </el-form-item>
        <el-form-item label="vip卡描述:" prop="vipCardDesc">
          <el-input type="textarea" v-model="params.vipCardDesc" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import { validatorIndex } from "@/utils/validator";
import { productTypes } from "../../../../config";

export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      type: "",
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      products: [
        { label: "铂金卡(月度会员)", value: 1 },
        { label: "钻石卡(季度会员)", value: 2 },
        { label: "至尊卡(年度会员)", value: 3 },
      ],
      productTypes,
      vipLevelTypeList: [
        { label: "VIP", value: 1 },
        { label: "超级VIP", value: 2 },
        { label: "SSVIP", value: 3 },
      ],
      positionTypeList: [],
      privileges: [],
      chanSplitMods: [
        { label: "不分成", value: 0 },
        { label: "正常分成", value: 1 },
      ],
      params: {
        prepaidPrivilege: this.createPrepaidPrivilege()
      },
      rules: {
        productName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        newName: [{ required: true, message: "请输入新名称", trigger: "blur" }],
        duration: [
          {
            pattern: /^(0|\+?[1-9][0-9]{0,4})$/,
            message: "最大不能超过99999",
            trigger: "blur",
          },
        ],
        originalPrice: [
          { required: true, message: "请输入原价", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        discountedPriceIos: [
          { required: true, message: "请输入IOS现价", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        discountedPriceAnd: [
          { required: true, message: "请输入安卓现价", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        goldVideoFreeDay: [
          {
            pattern: /^(0|\+?[1-9][0-9]{0,4})$/,
            message: "最大不能超过99999",
            trigger: "blur",
          },
        ],
        position: [
          { required: true, message: "请选择产品位置", trigger: "blur" },
        ],
        timesAWeek: [
          { required: true, message: "请输入每周可领次数", trigger: "blur" },
        ],
        louFengDiscount: [
          { required: true, message: "请输入楼凤折扣率", trigger: "blur" },
        ],
        serviceTime: [
          { required: true, message: "请输入服务时间", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    isPreSale() {
      return this.params.productType === 21
    }
  },
  mounted() {
    this.updatePrivileges()
  },
  methods: {
    createPrepaidPrivilege() {
      return {
        aiUndressLimitPerDay: undefined, // 每日ai脱衣次数限制
        coinVideoLimitPerDay: undefined, // 每日金币视频免费次数
        downloadLimitPerDay: undefined, // 每日下载次数限制
        luckyDrawLimitPerDay: undefined, // 每日抽奖次数限制
      }
    },
    updatePrivileges() {
      if (this.privileges.length > 0) return
      // 请求权益列表
      API.getProductBenefitList({pageNumber: 1, pageSize: 100})
        .then((res) => {
          if (res.code === 200) {
            const data = res.data || []
            this.privileges = data.map(v => ({ label: v.privilegeName, value: v.privilege }));
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //获取产品位置
    getNames() {
      this.loading = true;
      API.getNames(this.param)
        .then((res) => {
          if (res.code === 200 && res.data.list.length > 0) {
            this.positionTypeList = res.data.list.map((item, index) => {
              let positionObj = {};
              positionObj.key = index;
              positionObj.value = item;
              return positionObj;
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addProduct();
          } else {
            this.editProduct();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        prepaidPrivilege: this.createPrepaidPrivilege()
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.getNames();
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑VIP商品";
        Object.keys(data).forEach(key => {
          this.$set(this.params, key, data[key])
        })
        // Object.assign(this.params, data)
        this.id = data.id;
        if (this.params.payVidDiscount === 0) {
          this.params.payVidDiscount = undefined;
        }
        if (this.params.videoDiscount === 0) {
          this.params.videoDiscount = undefined;
        }
      } else {
        this.title = "新增VIP商品";
      }
      if (!this.params.prepaidPrivilege) this.$set(this.params, 'prepaidPrivilege', this.createPrepaidPrivilege())
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.bgImg = res.data.coverImg;
    },
    // 标签封面上传成功回掉新
    handleNewAvatarSuccess(res) {
      this.params.newBgImg = res.data.coverImg;
    },
    // 标签封面上传成功回掉新
    handleBgSuccess(res) {
      this.params.outBgImg = res.data.coverImg;
    },
    // 新增商品
    addProduct() {
      let params = this.params;
      if (params.productType === 0) {
        if (
          (!params.goldVideoCouponCount && params.goldVideoCouponNum) ||
          (params.goldVideoCouponCount && !params.goldVideoCouponNum)
        ) {
          this.$message.error("赠送金币券与数量不可单独配置!");
          this.flag = false;
          return;
        }
      }
      if (
        (params.loufengBookDiscount || params.loufengBookDiscountDays) &&
        !(params.loufengBookDiscount && params.loufengBookDiscountDays)
      ) {
        this.$message.error(
          "楼凤预约折扣与楼凤预约折扣时间要么都是空，要么都有值!!!"
        );
        this.flag = false;
        return;
      }
      API.getNewSection(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑商品
    editProduct() {
      let form = Object.assign(this.params, {
        id: this.id,
        actionDesc: this.params.actionDesc
          ? this.params.actionDesc
          : "ZERO_VALUE",
        privilegeDesc: this.params.privilegeDesc
          ? this.params.privilegeDesc
          : "ZERO_VALUE",
      });
      delete form.newPrivilege
      if (form.productType === 0) {
        if (
          (!form.goldVideoCouponCount && form.goldVideoCouponNum) ||
          (form.goldVideoCouponCount && !form.goldVideoCouponNum)
        ) {
          this.$message.error("赠送金币券与数量不可单独配置!");
          this.flag = false;
          return;
        }
      }
      if (
        (this.params.loufengBookDiscount ||
          this.params.loufengBookDiscountDays) &&
        !(
          this.params.loufengBookDiscount && this.params.loufengBookDiscountDays
        )
      ) {
        this.$message.error(
          "楼凤预约折扣与楼凤预约折扣时间要么都是空，要么都有值!"
        );
        this.flag = false;
        return;
      }
      API.getEditSection(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    handlePresaleSuccess(res) {
      this.params.advanceBgImg = res.data.coverImg;
    },
    handleNewPresaleSuccess(res) {
      this.params.advanceBgImgNew = res.data.coverImg;
    },
    handleFinalPaySuccess(res) {
      this.params.advanceBgImgFinalPay = res.data.coverImg;
    },
    handleNewFinalPaySuccess(res) {
      this.params.advanceBgImgFinalPayNew = res.data.coverImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-pay-box {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-input {
    width: 150px;
  }

  .flex-item {
    width: 90%;
    display: flex;

    .el-form-item {
      flex: 1;
    }
  }

  .form-flex-box {
    display: flex;

    .el-form-item {
      flex: 1;
    }

    .item-box {
      display: flex;
      flex-direction: column;
    }
  }

  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .privileges {
    ::v-deep .el-input--suffix {
      width: 480px;
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
